import axios from "axios"
import { Dispatch } from "../store.config"
import { BarDatum } from "@nivo/bar"

export interface InvoicePerMonth extends BarDatum {
  month: string
  number: number
}

export interface InvoicePerUser extends BarDatum {
  user: string
  number: number
}

export interface InvoicePerUserPeriod extends BarDatum {
  user: string
  number_first_period: number
  number_second_period: number
}

export interface CompanyByCodeApe extends BarDatum {
  month: string
}

export interface AutomationRate extends BarDatum {
  month: string
  automation_rate: number
}

export interface DocTypology extends BarDatum {
  month: string
  invoice_sell: number
  invoice_buy: number
  credit_note_sell: number
  credit_note_buy: number
  deactivate: number
}

export interface GetCompanyPerCodeApeResponse {
  codesApe: string[]
  activeCompanyByCodeApe: CompanyByCodeApe[]
}

const enum DashboardActionsEnum {
  GET_INVOICE_PER_MONTH_RESET = "DASHBOARDS/getInvoicePerMonthReset",
  GET_INVOICE_PER_MONTH_ATTEMPT = "DASHBOARDS/getInvoicePerMonthAttempt",
  GET_INVOICE_PER_MONTH_SUCCESS = "DASHBOARDS/getInvoicePerMonthSuccess",
  GET_INVOICE_PER_MONTH_ERROR = "DASHBOARDS/getInvoicePerMonthError",

  GET_ACTIVE_COMPANY_PER_MONTH_RESET = "DASHBOARDS/getActiveCompanyPerMonthReset",
  GET_ACTIVE_COMPANY_PER_MONTH_ATTEMPT = "DASHBOARDS/getActiveCompanyPerMonthAttempt",
  GET_ACTIVE_COMPANY_PER_MONTH_SUCCESS = "DASHBOARDS/getActiveCompanyPerMonthSuccess",
  GET_ACTIVE_COMPANY_PER_MONTH_ERROR = "DASHBOARDS/getActiveCompanyPerMonthError",

  GET_INVOICE_PER_USER_RESET = "DASHBOARDS/getInvoicePerUserReset",
  GET_INVOICE_PER_USER_ATTEMPT = "DASHBOARDS/getInvoicePerUserAttempt",
  GET_INVOICE_PER_USER_SUCCESS = "DASHBOARDS/getInvoicePerUserSuccess",
  GET_INVOICE_PER_USER_ERROR = "DASHBOARDS/getInvoicePerUserError",

  GET_INVOICE_PER_USER_PERIOD_RESET = "DASHBOARDS/getInvoicePerUserPeriodReset",
  GET_INVOICE_PER_USER_PERIOD_ATTEMPT = "DASHBOARDS/getInvoicePerUserPeriodAttempt",
  GET_INVOICE_PER_USER_PERIOD_SUCCESS = "DASHBOARDS/getInvoicePerUserPeriodSuccess",
  GET_INVOICE_PER_USER_PERIOD_ERROR = "DASHBOARDS/getInvoicePerUserPeriodError",

  GET_AUTOMATION_RATE_RESET = "DASHBOARDS/getAutomationRateReset",
  GET_AUTOMATION_RATE_ATTEMPT = "DASHBOARDS/getAutomationRateAttempt",
  GET_AUTOMATION_RATE_SUCCESS = "DASHBOARDS/getAutomationRateSuccess",
  GET_AUTOMATION_RATE_ERROR = "DASHBOARDS/getAutomationRateError",

  GET_DOC_TYPOLOGY_RESET = "DASHBOARDS/getDocTypologyReset",
  GET_DOC_TYPOLOGY_ATTEMPT = "DASHBOARDS/getDocTypologyAttempt",
  GET_DOC_TYPOLOGY_SUCCESS = "DASHBOARDS/getDocTypologySuccess",
  GET_DOC_TYPOLOGY_ERROR = "DASHBOARDS/getDocTypologyError",
}

export const getInvoicePerMonthResetAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_MONTH_RESET } as const)
export const getInvoicePerMonthAttemptAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_MONTH_ATTEMPT } as const)
export const getInvoicePerMonthSuccessAction = (payload: InvoicePerMonth[]) =>
  ({
    type: DashboardActionsEnum.GET_INVOICE_PER_MONTH_SUCCESS,
    payload,
  } as const)
export const getInvoicePerMonthErrorAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_MONTH_ERROR } as const)

export const getActiveCompanyPerMonthResetAction = () =>
  ({ type: DashboardActionsEnum.GET_ACTIVE_COMPANY_PER_MONTH_RESET } as const)
export const getActiveCompanyPerMonthAttemptAction = () =>
  ({ type: DashboardActionsEnum.GET_ACTIVE_COMPANY_PER_MONTH_ATTEMPT } as const)
export const getActiveCompanyPerMonthSuccessAction = (
  payload: GetCompanyPerCodeApeResponse
) =>
  ({
    type: DashboardActionsEnum.GET_ACTIVE_COMPANY_PER_MONTH_SUCCESS,
    payload,
  } as const)
export const getActiveCompanyPerMonthErrorAction = () =>
  ({ type: DashboardActionsEnum.GET_ACTIVE_COMPANY_PER_MONTH_ERROR } as const)

export const getInvoicePerUserResetAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_USER_RESET } as const)
export const getInvoicePerUserAttemptAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_USER_ATTEMPT } as const)
export const getInvoicePerUserSuccessAction = (payload: InvoicePerUser[]) =>
  ({
    type: DashboardActionsEnum.GET_INVOICE_PER_USER_SUCCESS,
    payload,
  } as const)
export const getInvoicePerUserErrorAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_USER_ERROR } as const)

export const getInvoicePerUserPeriodResetAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_USER_PERIOD_RESET } as const)
export const getInvoicePerUserPeriodAttemptAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_USER_PERIOD_ATTEMPT } as const)
export const getInvoicePerUserPeriodSuccessAction = (
  payload: InvoicePerUserPeriod[]
) =>
  ({
    type: DashboardActionsEnum.GET_INVOICE_PER_USER_PERIOD_SUCCESS,
    payload,
  } as const)
export const getInvoicePerUserPeriodErrorAction = () =>
  ({ type: DashboardActionsEnum.GET_INVOICE_PER_USER_PERIOD_ERROR } as const)

export const getAutomationRateResetAction = () =>
  ({ type: DashboardActionsEnum.GET_AUTOMATION_RATE_RESET } as const)
export const getAutomationRateAttemptAction = () =>
  ({ type: DashboardActionsEnum.GET_AUTOMATION_RATE_ATTEMPT } as const)
export const getAutomationRateSuccessAction = (payload: AutomationRate[]) =>
  ({
    type: DashboardActionsEnum.GET_AUTOMATION_RATE_SUCCESS,
    payload,
  } as const)
export const getAutomationRateErrorAction = () =>
  ({ type: DashboardActionsEnum.GET_AUTOMATION_RATE_ERROR } as const)

export const getDocTypologyResetAction = () =>
  ({ type: DashboardActionsEnum.GET_DOC_TYPOLOGY_RESET } as const)
export const getDocTypologyAttemptAction = () =>
  ({ type: DashboardActionsEnum.GET_DOC_TYPOLOGY_ATTEMPT } as const)
export const getDocTypologySuccessAction = (payload: DocTypology[]) =>
  ({
    type: DashboardActionsEnum.GET_DOC_TYPOLOGY_SUCCESS,
    payload,
  } as const)
export const getDocTypologyErrorAction = () =>
  ({ type: DashboardActionsEnum.GET_DOC_TYPOLOGY_ERROR } as const)

type DashboardActionType = ReturnType<
  | typeof getInvoicePerMonthResetAction
  | typeof getInvoicePerMonthAttemptAction
  | typeof getInvoicePerMonthSuccessAction
  | typeof getInvoicePerMonthErrorAction
  | typeof getActiveCompanyPerMonthResetAction
  | typeof getActiveCompanyPerMonthAttemptAction
  | typeof getActiveCompanyPerMonthSuccessAction
  | typeof getActiveCompanyPerMonthErrorAction
  | typeof getInvoicePerUserResetAction
  | typeof getInvoicePerUserAttemptAction
  | typeof getInvoicePerUserSuccessAction
  | typeof getInvoicePerUserErrorAction
  | typeof getInvoicePerUserPeriodResetAction
  | typeof getInvoicePerUserPeriodAttemptAction
  | typeof getInvoicePerUserPeriodSuccessAction
  | typeof getInvoicePerUserPeriodErrorAction
  | typeof getAutomationRateResetAction
  | typeof getAutomationRateAttemptAction
  | typeof getAutomationRateSuccessAction
  | typeof getAutomationRateErrorAction
  | typeof getDocTypologyResetAction
  | typeof getDocTypologyAttemptAction
  | typeof getDocTypologySuccessAction
  | typeof getDocTypologyErrorAction
>

export interface DashboardsState {
  getInvoicePerMonthStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  getActiveCompanyPerMonthStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  getInvoicePerUserStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  getInvoicePerUserPeriodStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  getAutomationRateStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  getDocTypologyStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  invoicePerMonth: InvoicePerMonth[]
  activeCompanyPerMonth: {
    keys: string[]
    data: CompanyByCodeApe[]
  }
  invoicePerUser: InvoicePerUser[]
  invoicePerUserPeriod: InvoicePerUserPeriod[]
  automationRate: AutomationRate[]
  docTypology: DocTypology[]
}

export const dashboardsInitialState: DashboardsState = {
  getInvoicePerMonthStatus: "IDLE",
  getActiveCompanyPerMonthStatus: "IDLE",
  getInvoicePerUserStatus: "IDLE",
  getInvoicePerUserPeriodStatus: "IDLE",
  getAutomationRateStatus: "IDLE",
  getDocTypologyStatus: "IDLE",
  invoicePerMonth: [],
  activeCompanyPerMonth: {
    keys: [],
    data: [],
  },
  invoicePerUser: [],
  invoicePerUserPeriod: [],
  automationRate: [],
  docTypology: [],
}

export function dashboardsReducer(
  state = dashboardsInitialState,
  action: DashboardActionType
): DashboardsState {
  switch (action.type) {
    case DashboardActionsEnum.GET_INVOICE_PER_MONTH_RESET: {
      return { ...state, getInvoicePerMonthStatus: "IDLE" }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_MONTH_ATTEMPT: {
      return { ...state, getInvoicePerMonthStatus: "LOADING" }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_MONTH_SUCCESS: {
      return {
        ...state,
        getInvoicePerMonthStatus: "SUCCESS",
        invoicePerMonth: action.payload,
      }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_MONTH_ERROR: {
      return { ...state, getInvoicePerMonthStatus: "ERROR" }
    }

    case DashboardActionsEnum.GET_ACTIVE_COMPANY_PER_MONTH_RESET: {
      return { ...state, getActiveCompanyPerMonthStatus: "IDLE" }
    }
    case DashboardActionsEnum.GET_ACTIVE_COMPANY_PER_MONTH_ATTEMPT: {
      return { ...state, getActiveCompanyPerMonthStatus: "LOADING" }
    }
    case DashboardActionsEnum.GET_ACTIVE_COMPANY_PER_MONTH_SUCCESS: {
      return {
        ...state,
        getActiveCompanyPerMonthStatus: "SUCCESS",
        activeCompanyPerMonth: {
          keys: action.payload.codesApe,
          data: action.payload.activeCompanyByCodeApe,
        },
      }
    }
    case DashboardActionsEnum.GET_ACTIVE_COMPANY_PER_MONTH_ERROR: {
      return { ...state, getActiveCompanyPerMonthStatus: "ERROR" }
    }

    case DashboardActionsEnum.GET_INVOICE_PER_USER_RESET: {
      return { ...state, getInvoicePerUserStatus: "IDLE" }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_USER_ATTEMPT: {
      return { ...state, getInvoicePerUserStatus: "LOADING" }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_USER_SUCCESS: {
      return {
        ...state,
        getInvoicePerUserStatus: "SUCCESS",
        invoicePerUser: action.payload,
      }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_USER_ERROR: {
      return { ...state, getInvoicePerUserStatus: "ERROR" }
    }

    case DashboardActionsEnum.GET_INVOICE_PER_USER_PERIOD_RESET: {
      return { ...state, getInvoicePerUserPeriodStatus: "IDLE" }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_USER_PERIOD_ATTEMPT: {
      return { ...state, getInvoicePerUserPeriodStatus: "LOADING" }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_USER_PERIOD_SUCCESS: {
      return {
        ...state,
        getInvoicePerUserPeriodStatus: "SUCCESS",
        invoicePerUserPeriod: action.payload,
      }
    }
    case DashboardActionsEnum.GET_INVOICE_PER_USER_PERIOD_ERROR: {
      return { ...state, getInvoicePerUserPeriodStatus: "ERROR" }
    }

    case DashboardActionsEnum.GET_AUTOMATION_RATE_RESET: {
      return { ...state, getAutomationRateStatus: "IDLE" }
    }
    case DashboardActionsEnum.GET_AUTOMATION_RATE_ATTEMPT: {
      return { ...state, getAutomationRateStatus: "LOADING" }
    }
    case DashboardActionsEnum.GET_AUTOMATION_RATE_SUCCESS: {
      return {
        ...state,
        getAutomationRateStatus: "SUCCESS",
        automationRate: action.payload,
      }
    }
    case DashboardActionsEnum.GET_AUTOMATION_RATE_ERROR: {
      return { ...state, getAutomationRateStatus: "ERROR" }
    }

    case DashboardActionsEnum.GET_DOC_TYPOLOGY_RESET: {
      return { ...state, getDocTypologyStatus: "IDLE" }
    }
    case DashboardActionsEnum.GET_DOC_TYPOLOGY_ATTEMPT: {
      return { ...state, getDocTypologyStatus: "LOADING" }
    }
    case DashboardActionsEnum.GET_DOC_TYPOLOGY_SUCCESS: {
      return {
        ...state,
        getDocTypologyStatus: "SUCCESS",
        docTypology: action.payload,
      }
    }
    case DashboardActionsEnum.GET_DOC_TYPOLOGY_ERROR: {
      return { ...state, getDocTypologyStatus: "ERROR" }
    }

    default:
      return { ...state }
  }
}

export const getInvoicePerMonthThunk =
  (fiduciaryId: number, year: number) =>
  (dispatch: Dispatch<DashboardActionType>) => {
    dispatch(getInvoicePerMonthAttemptAction())
    return axios
      .get<InvoicePerMonth[]>(
        `/fiduciaries/${fiduciaryId}/get_invoices_per_month`,
        {
          params: { year: year },
        }
      )
      .then((response) => {
        dispatch(getInvoicePerMonthSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getInvoicePerMonthErrorAction())
      })
  }
export const getActiveCompanyPerMonthThunk =
  (fiduciaryId: number, year: number) =>
  (dispatch: Dispatch<DashboardActionType>) => {
    dispatch(getActiveCompanyPerMonthAttemptAction())
    return axios
      .get<GetCompanyPerCodeApeResponse>(
        `/fiduciaries/${fiduciaryId}/get_active_company_by_code_ape`,
        {
          params: { year: year },
        }
      )
      .then((response) => {
        dispatch(getActiveCompanyPerMonthSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getActiveCompanyPerMonthErrorAction())
      })
  }
export const getInvoicePerUserThunk =
  (fiduciaryId: number, year: number) =>
  (dispatch: Dispatch<DashboardActionType>) => {
    dispatch(getInvoicePerUserAttemptAction())
    return axios
      .get<InvoicePerUser[]>(
        `/fiduciaries/${fiduciaryId}/get_invoices_per_user`,
        {
          params: { year: year },
        }
      )
      .then((response) => {
        dispatch(getInvoicePerUserSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getInvoicePerUserErrorAction())
      })
  }
export const getInvoicePerUserPeriodThunk =
  (
    fiduciaryId: number,
    startFirstPeriod: string,
    endFirstPeriod: string,
    startSecondPeriod: string,
    endSecondPeriod: string
  ) =>
  (dispatch: Dispatch<DashboardActionType>) => {
    dispatch(getInvoicePerUserPeriodAttemptAction())
    return axios
      .get<InvoicePerUserPeriod[]>(
        `/fiduciaries/${fiduciaryId}/get_invoices_per_user_period`,
        {
          params: {
            start_first_period: startFirstPeriod,
            end_first_period: endFirstPeriod,
            start_second_period: startSecondPeriod,
            end_second_period: endSecondPeriod,
          },
        }
      )
      .then((response) => {
        dispatch(getInvoicePerUserPeriodSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getInvoicePerUserPeriodErrorAction())
      })
  }
export const getAutomationRateThunk =
  (fiduciaryId: number, year: number) =>
  (dispatch: Dispatch<DashboardActionType>) => {
    dispatch(getAutomationRateAttemptAction())
    return axios
      .get<AutomationRate[]>(
        `/fiduciaries/${fiduciaryId}/get_automation_rate_per_month`,
        {
          params: { year: year },
        }
      )
      .then((response) => {
        dispatch(getAutomationRateSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getAutomationRateErrorAction())
      })
  }
export const getDocTypologyThunk =
  (fiduciaryId: number, year: number) =>
  (dispatch: Dispatch<DashboardActionType>) => {
    dispatch(getDocTypologyAttemptAction())
    return axios
      .get<DocTypology[]>(
        `/fiduciaries/${fiduciaryId}/get_doc_typology_per_month`,
        {
          params: { year: year },
        }
      )
      .then((response) => {
        dispatch(getDocTypologySuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getDocTypologyErrorAction())
      })
  }
